/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Information to collect from a patient before interacting with a ClinicRequest
 */
export type PreClinicStep = (typeof PreClinicStep)[keyof typeof PreClinicStep];

export const PreClinicStep = {
  insurance: "insurance",
  affiliation: "affiliation",
  current_state: "current_state",
  demographics: "demographics",
  medicare_insurance: "medicare_insurance",
} as const;
